import { Component, type ErrorInfo, type ReactNode } from "react";

type RideAnalysisChartBoundaryProps = {
  children: ReactNode;
};

type RideAnalysisChartBoundaryState = {
  hasError: boolean;
  message: string | null;
};

export class RideAnalysisChartBoundary extends Component<RideAnalysisChartBoundaryProps, RideAnalysisChartBoundaryState> {
  state: RideAnalysisChartBoundaryState = {
    hasError: false,
    message: null
  };

  static getDerivedStateFromError(error: unknown): RideAnalysisChartBoundaryState {
    return {
      hasError: true,
      message: error instanceof Error ? error.message : "Unknown chart rendering error"
    };
  }

  componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
    if (import.meta.env.DEV) {
      console.error("RideAnalysisChart render failure", error, errorInfo);
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <section className="panel ride-analysis-panel">
        <div className="ride-summary-header">
          <div>
            <p className="eyebrow">RIDE ANALYSIS</p>
            <h2>Ride chart could not be rendered</h2>
          </div>
        </div>
        {import.meta.env.DEV && this.state.message ? (
          <p className="summary-copy">{`Dev error: ${this.state.message}`}</p>
        ) : (
          <p className="summary-copy">Try uploading again after checking ride data integrity.</p>
        )}
      </section>
    );
  }
}
